import { X } from "lucide-react";

interface JsonViewerProps {
    data: any;
    onClose: () => void;
    title?: string;
  }
  
  const JsonModal: React.FC<JsonViewerProps> = ({ data, onClose, title = "JSON Viewer" }) => {
    if (!data) return null;
    return (
      <div className="p-10 fixed inset-0 z-20 bg-gray-600 bg-opacity-50 overflow-hidden w-screen h-screen flex items-center justify-center">
        <div className="w-[80vw] p-2 bg-white rounded-lg flex flex-col h-full">
            <div className="flex justify-between items-center mb-2">
                <h3 className="text-lg text-custom-blue7 font-semibold">{title}</h3>
                <button
                    onClick={onClose}
                    className="p-2 bg-custom-blue7 rounded-full"
                >
                    <X size={20} className="text-gray-50" />
                </button>
            </div>
            <pre className="bg-custom-blue8 text-custom-blue7 p-4 rounded text-sm overflow-x-auto max-h-[500px]">
                {JSON.stringify(data, null, 2)}
            </pre>
            </div>
        </div>    
    );
  };
  
  export default JsonModal;  